<template>
  <div>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Review Details
        </p>
      </v-card-title>
      <v-card-text class="justify-center">
        <div style="margin-top:-10px">
          <p class="title-text-style">
            Visit Purpose: <font
              :color="getStatusColor(visitStatus.visit_status)"
            >
              {{ visitStatus.visit_status | statusFormat }}
            </font>
          </p>
          <p class="title-text-style">
            Reason:- <font
              v-if="visitStatus.pending_reason !== null"
              class="value-text-style"
            >
              {{ visitStatus.pending_reason }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
          <p
            class="title-text-style"
          >
            Check-out Gate: <font
              v-if="locationName.name !== undefined"
              class="value-text-style"
            >
              {{ locationName.name }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
          <p class="title-text-style">
            Worker Clock:
            <check-in-clock style="color:#FF3700; font-size:16px;" />
          </p>
        </div>
      </v-card-text>
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="checkOut()"
    >
      Check-out
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
    <centre-spinner
      :loading="loading"
    />
  </div>
</template>

  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';
  import moment from 'moment';
  import CheckInClock from 'src/views/dashboard/Components/CheckInClock.vue';
  export default {
    name: 'ReviewVisitorCheckOut',
    components: {
      'centre-spinner': spinner,
      'check-in-clock': CheckInClock,
    },
    filters: {
      statusFormat (val) {
        if (val === 'pending') {
          return 'Pending';
        } else {
          return 'Completed*';
        }
      },
    },
    data: () => ({
      loading: false,
    }),
    computed: {
      visitStatus () {
        return this.$store.getters['swiftuser/getVisitStatus'];
      },
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      checkOutMethodType () {
        return this.$store.getters['swiftuser/getCheckOutMethodType'];
      },
      manualCheckoutDetails () {
        return this.$store.getters['swiftuser/getManualCheckoutDetails'];
      },
      locationName () {
        return this.$store.getters['swiftuser/getLocationName'];
      },
    },
    methods: {
      convertToGmt (date) {
        return moment(date).utc();
      },
      checkOut () {
        this.loading = true;
        const siteId = this.$route.params.siteId;
        if (this.checkOutMethodType === 'manual-offsite') {
          this.$store.dispatch('swiftuser/checkOutUser', {
            checkOutTime: {
              checkout_time: this.convertToGmt(this.manualCheckoutDetails.checkOutTime),
              type: this.checkOutMethodType,
              manual_checkout_reason: this.manualCheckoutDetails.reason,
              checkout_gate: null,
              latitude: null,
              longitude: null,
            },
            checkInId: this.activeCheckInDetails.id,
          }).then(response => {
            this.completeCheckOutProcess();
          }).catch(errors => {
            this.loading = false;
          });
        } else {
          this.$store.dispatch('swiftuser/checkOutUser', {
            checkOutTime: {
              checkout_time: moment.utc().format(),
              type: this.checkOutMethodType,
              manual_checkout_reason: null,
              checkout_gate: siteId,
              latitude: null,
              longitude: null,
            },
            checkInId: this.activeCheckInDetails.id,
          }).then(response => {
            this.completeCheckOutProcess();
          }).catch(errors => {
            this.loading = false;
          });
        }
      },
      async completeCheckOutProcess () {
        await this.$store.dispatch('swiftuser/sendVisitStatus', {
          statusDetails: {
            status: this.visitStatus.visit_status,
            pending_reason: this.visitStatus.pending_reason,
          },
          checkInId: this.activeCheckInDetails.id,
        }).then(response => {
          this.loading = false;
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-out completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          localStorage.removeItem('checkInTime');
          localStorage.removeItem('checkIn');
          this.$emit('checkout-completed');
        }).catch(() => {
          this.loading = false;
        });
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckOut' });
        }, 1000);
      },
      getStatusColor (val) {
        if (val === 'active') {
          return '#2E7D32';
        } else if (val === 'pending') {
          return '#C62828';
        } else if (val === 'completed') {
          return '#FF3700';
        } else {
          return '#EF6C00';
        }
      },
    },
  };
</script>
